/* eslint-disable import/prefer-default-export */
import { IClientDataState } from '.'
import { RootStore } from '../store'

export const selectClientData = (state: RootStore): IClientDataState => state.clientData
